import React from 'react';
import { motion } from 'framer-motion';
export interface Logo {
  src: string;
  alt: string;
}
export interface LogoMarqueeProps {
  logos: Logo[];
  title?: string;
  speed?: number;
  'data-id'?: string;
}
export function LogoMarquee({
  logos,
  title = 'Trusted by 30+ D2D & Direct Sales Companies',
  speed = 30,
  'data-id': dataId
}: LogoMarqueeProps) {
  // Duplicate logos to create seamless loop
  const duplicatedLogos = [...logos, ...logos, ...logos];
  return <section data-id={dataId} className="relative bg-slate-50 py-12 w-full">
      <div className="max-w-7xl mx-auto px-8 mb-8" data-id="element-88">
        <p className="text-center text-slate-500 text-xs font-semibold uppercase tracking-wider" data-id="element-89">
          {title}
        </p>
      </div>
      <div className="relative overflow-hidden" data-id="element-90">
        <motion.div className="flex items-center" animate={{
        x: [0, -((120 + 32) * logos.length)] // smaller width + gap
      }} transition={{
        x: {
          repeat: Infinity,
          repeatType: 'loop',
          duration: speed,
          ease: 'linear'
        }
      }} data-id="element-91">
          {duplicatedLogos.map((logo, index) => <div key={index} className="flex-shrink-0 mx-4" data-id="element-92">
              <div className="flex h-16 w-28 items-center justify-center bg-white shadow-sm border border-slate-200 rounded p-3" data-id="element-93">
                <img src={logo.src} alt={logo.alt} className="w-full h-full object-contain" style={{
              objectFit: 'contain'
            }} data-id="element-94" />
              </div>
            </div>)}
        </motion.div>
        {/* Gradient overlays */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-40 bg-gradient-to-r from-slate-50 to-transparent z-10" data-id="element-95" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-40 bg-gradient-to-l from-slate-50 to-transparent z-10" data-id="element-96" />
      </div>
    </section>;
}